export const FETCH_DB_LOG_HEADERS = 'FETCH_DB_LOG_HEADERS';
export const FETCH_DB_LOG_DETAIL = 'FETCH_DB_LOG_DETAIL';
